// IBK기업은행 입출금 알림(문자·유료) 신청 안내 (2026-07-04 오너 라이브 실측).
// Type A: 6자리 인증번호가 게이트웨이로 수신됨(신한/농협 패턴).
import type { GuideStep } from './BankRegistrationGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

export const IBK_REQUEST_CODE_STEPS: GuideStep[] = [
  { title: '기업은행 앱 → 메뉴 → 설정 → 알림설정' },
  { title: '"입출금 알림"에서 문자(유료) 선택 → 신청하기' },
  {
    title: '알림구분 "입·출금"(또는 "입금"), 알림시간 "24시간", 계좌번호표시구분 "일반계좌번호"',
    detail: '계좌번호표시구분을 "일반계좌번호"로 해야 입금이 자동으로 매칭돼요.',
    detailTone: 'danger',
  },
  {
    title: '"알림 휴대폰번호"의 [인증하기] → 아래 셀러헬퍼 번호 입력',
    detail: `내 휴대폰 번호가 아니라 ${GATEWAY_NUMBER_DISPLAY}를 입력해주세요.`,
    detailTone: 'danger',
  },
  { title: '[인증번호 발송]을 누르기' },
];

export const IBK_COMPLETE_REGISTRATION_STEPS: GuideStep[] = [
  { title: '위에 표시된 6자리 인증번호를 기업은행 앱에 입력' },
  { title: '확인을 눌러 신청 완료' },
];

export const IBK_NOTIFY_OPTIONS: GuideStep[] = [
  {
    title: '계좌번호표시구분: "일반계좌번호"',
    titleTone: 'danger',
    detail: '입금 자동 매칭에 계좌번호가 필요해요("일반계좌번호"로 설정).',
    detailTone: 'danger',
  },
  { title: '알림구분: "입·출금" 또는 "입금"' },
  { title: '알림시간: "24시간"' },
];
